// @flow
import JQueryView, { on } from '../../common/JQueryView';

declare var $: any;

export default class FormView extends JQueryView {
  constructor() {
    super('.simple_form');
  }

  @on('click .js-toggle-password')
  onToggleShowPassword(e: any) {
    $(e.currentTarget).toggleClass('is-checked');

    if ($(e.currentTarget).hasClass('is-checked')) {
      $('#user_password').attr('type', 'text');
    } else {
      $('#user_password').attr('type', 'password');
    }
  }
}
